import { Order, ORDER_SOURCE_IDS, DELIVERY_METHODS, DeliveryMethod } from "@/pages/Orders/orders.types";
import { LCR_STATUS, LCR_STATUS_LABELS } from "@/services/orders/lcr-order.types";

const INTERNATIONAL_PREFIX = "+";
const WHITESPACE = /\s/;

export type StatusTone = "done" | "alert" | "cancelled" | "progress";

const DONE_STATUSES: string[] = ["COMPLETED", "DELIVERED", LCR_STATUS_LABELS[LCR_STATUS.delivered]];
const ALERT_STATUSES: string[] = [
  LCR_STATUS_LABELS[LCR_STATUS.processingIssue],
  LCR_STATUS_LABELS[LCR_STATUS.error],
];
const CANCELLED_STATUSES: string[] = ["CANCELLED", LCR_STATUS_LABELS[LCR_STATUS.cancelled]];

export const getStatusTone = (status: string): StatusTone => {
  if (DONE_STATUSES.includes(status)) return "done";
  if (ALERT_STATUSES.includes(status)) return "alert";
  if (CANCELLED_STATUSES.includes(status)) return "cancelled";
  return "progress";
};

const PICKUP_LABEL = "Pick up";

const DELIVERY_METHOD_LABELS: Record<DeliveryMethod, string> = {
  [DELIVERY_METHODS.shipToHome]: "Ship",
  [DELIVERY_METHODS.businessServiceCenter]: PICKUP_LABEL,
  [DELIVERY_METHODS.itOffice]: PICKUP_LABEL,
};

export const getDeliveryMethodLabel = (method?: string): string =>
  method ? DELIVERY_METHOD_LABELS[method as DeliveryMethod] ?? method : "-";

export const canCancel = (order: Order): boolean => order.source !== ORDER_SOURCE_IDS.lcr;


/**
 * Phone numbers are stored as the national number. A number stored with spaces
 * carries its country code as the first group, so only that form gets a plus sign.
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const trimmedPhoneNumber = phoneNumber.trim();
  const hasSeparatedCountryCode =
    WHITESPACE.test(trimmedPhoneNumber) && !trimmedPhoneNumber.startsWith(INTERNATIONAL_PREFIX);
  return hasSeparatedCountryCode ? `${INTERNATIONAL_PREFIX}${trimmedPhoneNumber}` : trimmedPhoneNumber;
};
